<main class="main-container">
  <div class="window-padding-full">
    <section class="two-column-layout flex flex-row items-center">
      <div class="left-container h-screen overflow-y-auto bg-ls_cream w-full">
        <div class="language-selector" [class.invisible]="!uiState.showLanguageSelector()">
          <app-language-selector
            [currentLang]="currentLang"
            (languageSelected)="switchLanguage($event)"
          />
        </div>
        <div class="language-selector"></div>
        <div>
          <router-outlet />
        </div>
      </div>
      <hr />
      <div class="image-container w-1/2 h-screen pt-10">
        <app-right-panel />
      </div>
    </section>
  </div>
</main>
<app-footer />
<app-cookie-banner />
<app-toast />
